export default function isALoomVideo(loomUrl: string): string | null {
	const loomRe = /http(()|(s)):\/\/((www.)|())loom.com\/((share)|(embed))\/.[^ ]*/g
	let loomUrlArr = loomRe.exec(loomUrl)

	if (loomUrlArr === null) {
		return null
	} else {
		let embedUrl = loomUrlArr[0]

		if (embedUrl.includes("share")) {
			embedUrl = embedUrl.replace("share", "embed")
			return embedUrl
		}

		return embedUrl
	}
}
